import { graphql } from 'gatsby';
import Tabs from './components/Tabs/Tabs';
import Link from '@/components/Link/Link';
import { applyPaddingCSS } from '@/utils/generatePadding';
import { type BlockHTMLId } from '@/utils/renderBlock';

import {
  StyledContainer,
  StyledEyebrow,
  StyledHeader,
  StyledHeadline,
  StyledSection,
} from './TabbedBlock.styles';

const MINIMUM_NUMBER_OF_TABS = 2;

const TabbedBlock = ({
  tabbedBlockElements: elements,
  system,
  id,
}: Queries.TABBED_BLOCKFragment & BlockHTMLId) => {
  const { cta, eyebrow, headline, tabs, options } = elements;
  const hasWhiteBackground = !!options?.value?.includes('white_background');
  const tabsValue = tabs?.value;
  const hasHeader = Boolean(eyebrow?.value || headline?.value || cta?.value);

  if (tabsValue.length < MINIMUM_NUMBER_OF_TABS) {
    return null;
  }

  return (
    <StyledSection css={applyPaddingCSS(elements)} data-codename={system.codename} id={id}>
      {hasHeader && (
        <StyledContainer>
          <StyledHeader>
            {eyebrow?.value && <StyledEyebrow>{eyebrow.value}</StyledEyebrow>}
            {headline?.value && <StyledHeadline>{headline.value}</StyledHeadline>}
            {cta?.value && <Link {...cta.value} variant="primary" />}
          </StyledHeader>
        </StyledContainer>
      )}
      <Tabs items={tabsValue} hasWhiteBackground={hasWhiteBackground} />
    </StyledSection>
  );
};

export default TabbedBlock;

export const fragment = graphql`
  fragment TABBED_BLOCK on kontent_item_tabbed_block {
    system {
      codename
      id
      type
    }
    tabbedBlockElements: elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      cta {
        value {
          ...LINK
        }
      }
      eyebrow {
        value
      }
      headline {
        value
      }
      tabs {
        value {
          ...TAB
        }
      }
      options {
        value
      }
    }
  }
`;
